import { Routes } from '@angular/router';
import {ENV } from '@env/environment';


export const routes: Routes = [

  {
    path:"",
    loadChildren: () => import("./layouts/default/default.module").then(m=>m.DefaultModule),
  },
  {
    path:"",
    loadChildren: () => import("./layouts/auth/auth.module").then(m=>m.AuthModule),
  },
  {
    path: 'site-offline',
    loadComponent: () => import("./core/site-offline/site-offline.component").then(m =>m.SiteOfflineComponent)
  },
  {
    path: '**',
    loadComponent: () => import("./core/not-found/not-found.component").then(m =>m.NotFoundComponent)
  },
];

if(ENV.type === "DEV"){
  let scratchpadRoute =   {
    path: 'scratchpad',
    loadComponent: () => import("./pages/scratchpad/scratchpad.component").then(m =>m.ScratchpadComponent)
  }
  routes.splice(1, 0, scratchpadRoute);
}
